<template>
  <div v-if="errorMsg" class="d-flex flex-row align-center">
    <v-icon :color="$finColors.accentRed"
            :size="42"
            class="mr-4">
      icon-hint
    </v-icon>
    <p v-if="!displayHtml" class="mb-0">
      {{ errorMsg }}
    </p>
    <p v-else class="mb-0" v-html="errorMsg"/>
  </div>
</template>

<script>
export default {
  name: 'FinErrorDisplay',
  props: {
    errorMsg: {
      type: String
    },
    displayHtml: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
